import React from "react";

export const boundedScaleValue = value => Math.max(0, Math.min(100, Number(value)));
export const scalePercent = value => `${boundedScaleValue(value)}%`;
export const scaleSpan = (low, high) => `${Math.max(0, boundedScaleValue(high) - boundedScaleValue(low))}%`;

export default function FixedScaleRangeBand({
  ariaLabel,
  learnerValue,
  learnerLabel,
  primaryRange,
  secondaryRange = null,
  rangeLabels,
  children,
  footer = null,
  className = "",
  ...figureProps
}) {
  const learner = boundedScaleValue(learnerValue);
  return <figure className={`av-governed-feedback-band ${className}`.trim()} data-visual-owner="fixed-scale-range-band" {...figureProps}>
    <div className="av-governed-feedback-band__axis-labels" aria-hidden="true"><span>0</span><span>100</span></div>
    <div className="av-governed-feedback-band__plot" role="img" aria-label={ariaLabel}>
      <span className="av-governed-feedback-band__learner-label" data-testid="expert-band-learner-label" style={{ "--label-left": scalePercent(learner) }}>{learnerLabel}</span>
      <span className="av-governed-feedback-band__axis" />
      <span
        className={`av-governed-feedback-band__range ${primaryRange.className || ""}`.trim()}
        data-testid={primaryRange.testId}
        style={{ "--band-left": scalePercent(primaryRange.low), "--band-width": scaleSpan(primaryRange.low, primaryRange.high) }}
      />
      {secondaryRange && <span
        className={`av-governed-feedback-band__range ${secondaryRange.className || ""}`.trim()}
        data-testid={secondaryRange.testId}
        style={{ "--band-left": scalePercent(secondaryRange.low), "--band-width": scaleSpan(secondaryRange.low, secondaryRange.high) }}
      />}
      {children}
      <span className="av-governed-feedback-band__learner" data-testid="expert-band-learner" style={{ "--tick-left": scalePercent(learner) }} />
    </div>
    <div className="av-governed-feedback-band__range-labels" aria-hidden="true">
      <span className="av-governed-feedback-band__range-label av-governed-feedback-band__range-label--low" data-testid={rangeLabels.lowTestId} style={{ "--label-left": scalePercent(rangeLabels.lowPosition) }}>{rangeLabels.lowLabel}</span>
      <span className="av-governed-feedback-band__range-label av-governed-feedback-band__range-label--high" data-testid={rangeLabels.highTestId} style={{ "--label-left": scalePercent(rangeLabels.highPosition) }}>{rangeLabels.highLabel}</span>
    </div>
    {footer}
  </figure>;
}
